import { createRouter, createWebHistory } from 'vue-router'

// 基础路由（不要直接导出）
const baseRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/view/login/login.vue'),
    meta: { title: '登录', requiresAuth: false }
  },
  {
    path: '/404',
    name: 'Page404',
    component: () => import('@/view/error/404.vue'),
    meta: { hidden: true }
  }
]

// 创建命名导出的常量
export const constantRoutes = [...baseRoutes]

// 创建路由实例
export const router = createRouter({
  history: createWebHistory(),
  routes: [...baseRoutes]
})

// 重置路由函数（改进版）
export function resetRouter() {
  const currentRoutes = router.getRoutes()
  currentRoutes.forEach(route => {
    if (route.name && !baseRoutes.some(r => r.name === route.name)) {
      router.removeRoute(route.name)
    }
  })
}

export default router